var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2228 10.2112H12.3994V2.58584C12.3994 1.96451 11.9087 1.45873 11.3053 1.45873H8.75252V2.91748H10.9406V11.67H14.2228C14.4243 11.67 14.5875 11.5068 14.5875 11.3053V10.5759C14.5875 10.3744 14.4243 10.2112 14.2228 10.2112ZM7.11689 0.0229987L2.74063 1.15672C2.41583 1.24083 2.18813 1.54306 2.18813 1.88997V10.2112H0.364688C0.163198 10.2112 0 10.3744 0 10.5759V11.3053C0 11.5068 0.163198 11.67 0.364688 11.67H8.02314V0.75625C8.02314 0.264377 7.57731 -0.0964366 7.11689 0.0229987ZM6.01736 6.56436C5.71535 6.56436 5.47032 6.23774 5.47032 5.83499C5.47032 5.43224 5.71535 5.10561 6.01736 5.10561C6.31936 5.10561 6.56439 5.43224 6.56439 5.83499C6.56439 6.23774 6.31936 6.56436 6.01736 6.56436Z",
    fill: "#727272"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoor);
export default __webpack_public_path__ + "static/media/Door.68da5ae4013d933140c65f082ef0ceff.svg";
export { ForwardRef as ReactComponent };